import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class tabsComunicationService{
  // Use WritableSignal to allow updates
  private _data: WritableSignal<{ [key: string]: any }> = signal({});

  // Getter for readonly access
  get data() {
    return this._data;
  }

  // Function to update the signal's value
  updateData(newData: any) {
    this._data.set(newData); // Set the new value directly
  }
}
